// @flow

import React from 'react';
import { connect } from 'react-redux';
import { HashRouter, Route, Redirect, Switch } from 'react-router-dom';

import ScribeHeaderContainer from '../modules/scribe/ScribeHeaderContainer';
import ScribeLoginContainer from '../modules/scribe/ScribeLoginContainer';
import ScribeWelcomeContainer from '../modules/scribe/ScribeWelcomeContainer';
import ScribeConversationContainer from '../modules/scribe/ScribeConversationContainer';
import DownloadAppComponent from '../components/DownloadAppComponent';
import ScribeDashboardContainer from '../modules/scribe/ScribeDashboard';
import MainContainer from '../modules/scribe/MainContainer';
import { onkeyup, onkeydown } from '../actions/shortcut';
import ScribeConversationsContainer from '../modules/scribe/ScribeConversationsContainer';

const PrivateRoute = ({
  component: Component,
  authenticate,
  redirect,
  ...rest
}: {
  component: Object,
  authenticate: Function,
  redirect: string,
}) => (
  <Route
    {...rest}
    render={props =>
      authenticate() ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: redirect,
          }}
        />
      )
    }
  />
);

type Props = {
  AppWrapper: Function,
  avaId: string,
  captioner: Object,
  features: Object,
  onkeyup: Function,
  onkeydown: Function,
  token: string,
};

class Routes extends React.Component<Props> {
  shouldComponentUpdate() {
    return false;
  }

  componentDidMount() {
    // eslint-disable-next-line
    const { onkeydown, onkeyup } = this.props;
    window.document.onkeydown = onkeydown;
    window.document.onkeyup = onkeyup;
  }

  render() {
    const { AppWrapper } = this.props;

    const scribeAuthenticate = () => {
      const { captioner, features } = this.props;

      return captioner && features && features.scribe;
    };
    const webAppAuthenticate = () => {
      const { avaId } = this.props;
      return avaId && avaId !== '';
    };
    return (
      <div id="gesture">
        <HashRouter>
          <AppWrapper>
            <Switch>
              <Route path="/scribe">
                <div>
                  <ScribeHeaderContainer product="scribe" />
                  <MainContainer>
                    <Switch>
                      <Route
                        exact
                        render={props => (
                          <ScribeWelcomeContainer {...props} product="scribe" />
                        )}
                        path="/scribe"
                      />
                      <Route
                        render={props => (
                          <ScribeLoginContainer {...props} product="scribe" />
                        )}
                        path="/scribe/login"
                      />
                      <PrivateRoute
                        path="/scribe/transcript"
                        component={ScribeConversationContainer}
                        authenticate={scribeAuthenticate}
                        redirect="/scribe"
                      />
                    </Switch>
                  </MainContainer>
                </div>
              </Route>
              <Route path="/web">
                <div>
                  <ScribeHeaderContainer product="web" />
                  <MainContainer>
                    <Switch>
                      <Route
                        exact
                        render={props => (
                          <ScribeWelcomeContainer {...props} product="web" />
                        )}
                        path="/web"
                      />
                      <Route
                        render={props => (
                          <ScribeLoginContainer {...props} product="web" />
                        )}
                        path="/web/login"
                      />
                      <PrivateRoute
                        path="/web/scribe-dashboard"
                        component={ScribeDashboardContainer}
                        authenticate={webAppAuthenticate}
                        redirect="/web"
                      />
                      <PrivateRoute
                        path="/web/conversations"
                        component={ScribeConversationsContainer}
                        authenticate={webAppAuthenticate}
                        redirect="/web"
                      />
                      <PrivateRoute
                        path="/web/transcript"
                        component={ScribeConversationContainer}
                        authenticate={webAppAuthenticate}
                        redirect="/web"
                      />
                    </Switch>
                  </MainContainer>
                </div>
              </Route>
              <Route path="/">
                <div>
                  <ScribeHeaderContainer />
                  <MainContainer>
                    <Switch>
                      <Route
                        exact
                        component={DownloadAppComponent}
                        path="/download"
                      />
                      <Redirect to="/web" />
                    </Switch>
                  </MainContainer>
                </div>
              </Route>
              <Redirect from="*" to="/web" />
            </Switch>
          </AppWrapper>
        </HashRouter>
      </div>
    );
  }
}

const mapStateToProps = ({
  scribeSession: { captioner, features, avaId },
  scribeConversation: { token },
  currentUser,
}) => ({
  avaId: (captioner || {}).avaId || avaId,
  currentUser,
  captioner,
  features,
  token,
});
export default connect(
  mapStateToProps,
  { onkeydown, onkeyup }
)(Routes);
